import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";
import SectionHeader from "../partials/SectionHeader";
import { customers } from "../../../data/customers";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const OurCustomers = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap justify-content-between px-1");

  const sectionHeader = {
    title: "Our",
    title_highlight: "Customers",
  };

  const sorted = [...customers].sort((a, b) => a.order - b.order);

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content pb-0" />
          <div className={tilesClasses}>
            {sorted.map((customer, index) => (
              <div
                key={customer.id}
                className="tiles-customer-logo reveal-from-top"
                data-reveal-delay={String(100 + index * 50)}
              >
                <div className="d-flex flex-column">
                  <div className="d-flex align-items-center justify-content-center d-flex-1 mb-16">
                    <div className="h-content-for-w-img-80px">
                      <img
                        src={customer.logo}
                        alt={customer.name}
                        className="w-img-80px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

OurCustomers.propTypes = propTypes;
OurCustomers.defaultProps = defaultProps;

export default OurCustomers;
